//判断浏览器是否可以打开
const isBrowserOpen = function() {
  if (navigator.userAgent.toLowerCase().indexOf('micromessenger') == -1) { //只有微信才可以打开
    return true
  }else{
    return false
  }
}

//判断浏览器是否是微信PC端
const isWxPc = function () {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    var system = {
      win: false,
      mac: false
    };
    //检测平台
    var p = navigator.platform;
    system.win = p.indexOf("Win") == 0;
    system.mac = p.indexOf("Mac") == 0;
    if (system.win || system.mac) {
      //在微信PC端上打开内置浏览器
      return true
    } else {
      //非微信PC端上打开内置浏览器
      return false
    }
  }
  return false
}

//判断是否是IOS终端
const isIOS = function () {
  let u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

//判断是否是IPhoneX及以上的分辨率（手机底部带黑色横条）
const isIphoneX = function () {
  if((screen.width==375 && screen.height==812) //iphone11
    || (screen.width==414 && screen.height==896) //iphone11 Pro Max
    || (screen.width==360 && screen.height==780) //ipnone12 mini
    || (screen.width==390 && screen.height==844) //ipnone12 Pro
    || (screen.width==428 && screen.height==926) //iphone12 Pro Max
  ){
    return true
  } else {
    return false
  }
}

export default {
  isBrowserOpen,
  isWxPc,
  isIOS,
  isIphoneX
}



// WEBPACK FOOTER //
// ./src/utils/service.js